"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PURCHASE_TAG = exports.ICONS = exports.COLOR = void 0;
var ICONS = {
  EXPAND_LESS: 'ExpandLessIcon',
  EXPAND_MORE: 'ExpandMoreIcon',
  CHECK_CIRCLE: 'CheckCircleIcon'
};
exports.ICONS = ICONS;
var PURCHASE_TAG = {
  backgroundColor: 'greenLight',
  label: 'Purchased',
  textColor: 'tertiaryDark'
};
exports.PURCHASE_TAG = PURCHASE_TAG;
var COLOR = {
  DEFAULT: 'secondary',
  PURCHASED: 'greyLight',
  NEUTRAL: 'neutral'
};
exports.COLOR = COLOR;